<template>
  <div>
    <button
      type="button"
      class="btn btn-default grid-history pull-right"
      @click="showHistory"
    >
      <i class="fa fa-history"></i>
      {{ translate("entity_logger.modal.show_button_title") }}
    </button>
    <div
      v-if="isVisible"
      class="bootbox modal fade history-modal in"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="bootbox-close-button close"
              @click="hideHistory"
            >
              ×
            </button>
            <h4 class="modal-title">{{ translate("entity_logger.modal.title") }}</h4>
          </div>
          <div class="modal-body">
            <div class="bootbox-body">
              <div id="history-search">
                <div class="date-container">
                  <div class="date-wrapper">
                    <span>{{ translate("entity_logger.modal.date_from") }}</span>
                    <date-picker
                      v-model="searchForm.dateFrom"
                      :time="false"
                      class="grid-filter-input-query-from"
                      name="date_from"
                      with-label="true"
                      title="Data od"
                    >
                    </date-picker>
                  </div>
                  <div class="date-wrapper">
                    <span>{{ translate("entity_logger.modal.date_to") }}</span>
                    <date-picker
                      v-model="searchForm.dateTo"
                      :time="false"
                      class="grid-filter-input-query-to"
                      name="date_to"
                      with-label="true"
                      title="Data do"
                    >
                    </date-picker>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn btn-success"
                  :disabled="!isCorrectDateRange || loading"
                  @click="fetchHistory"
                >
                  <span class="glyphicon glyphicon-search"></span>
                  {{ translate("entity_logger.modal.submit_button_title") }}
                </button>
                <span v-if="!isCorrectDateRange" class="error">
                  {{ translate("entity_logger.error.search") }}
                </span>
              </div>
              <ring-loader v-if="loading"></ring-loader>
              <div
                v-if="historyItems.length && !loading"
                class="table-responsive"
              >
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>{{ translate("entity_logger.list.date") }}</th>
                      <th>{{ translate("entity_logger.list.user") }}</th>
                      <th>{{ translate("entity_logger.list.type") }}</th>
                      <th>{{ translate("entity_logger.list.entity") }}</th>
                      <th>{{ translate("entity_logger.list.data_changes") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, itemIndex) in historyItems" :key="itemIndex">
                      <td>{{ item.event_date }}</td>
                      <td>{{ getUsername(item.user, item.impersonator, item.is_system_changed) }}</td>
                      <td>{{ translate("entity_logger.types." + item.type) }}</td>
                      <td v-if="item.is_overproduction_update">{{ item.object_name }}</td>
                      <td v-else>{{ translate("entities." + item.object_name) }}({{item.object_id}})</td>
                      <td style="max-width: 70%; min-width: 50%;">
                        <table
                          v-if="item.data"
                          class="data-table custom-striped"
                        >
                          <thead>
                            <tr>
                              <th>{{ translate("entity_logger.list.attribute") }}</th>
                              <th>{{ translate("entity_logger.list.old_value") }}</th>
                              <th>{{ translate("entity_logger.list.new_value") }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(data, key) in item.data" :key="key">
                              <td class="attribute-column">{{ key }}</td>
                              <td
                                v-if="data.old !== undefined || data.old === null"
                                class="data-column"
                              >
                                {{ data.old }}
                              </td>
                              <td v-else class="data-column">---</td>
                              <td
                                v-if="data.new !== undefined || data.new === null"
                                class="data-column"
                              >
                                {{ data.new }}
                              </td>
                              <td v-else class="data-column">---</td>
                            </tr>
                          </tbody>
                        </table>
                        <span v-else>---</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <span v-else-if="!loading" class="no-records">
                {{ translate("entity_logger.list.no_records") }}
              </span>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn btn-default"
              @click="hideHistory"
            >
              {{ translate("entity_logger.modal.close_button_title") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datePicker from '../../component/datePicker.vue'
import moment from 'moment'
import axios from 'axios'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import toastr from '../toastr'

export default {
  components: {
    datePicker,
    RingLoader
  },
  props: {
    routeName: {
      type: String,
      required: true
    },
    entityName: {
      type: String,
      default: null
    },
    entityId: {
      type: [String, Number],
      default: null
    },
    date: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isVisible: false,
      historyItems: [],
      searchForm: {
        dateFrom: moment().subtract(60, 'days').locale('pl').format('YYYY-MM-DD'),
        dateTo: moment().locale('pl').format('YYYY-MM-DD')
      },
      loading: false,
      init: true
    }
  },
  computed: {
    isCorrectDateRange() {
      return (moment(this.searchForm.dateTo).diff(moment(this.searchForm.dateFrom), 'days') <= 60)
    }
  },
  watch: {
    entityId() {
      if (this.historyItems.length) {
        this.fetchHistory()
      }
    },
    isVisible($newValue) {
      if ($newValue) {
        document.body.classList.add('scrollbar-hidden')
      } else {
        document.body.classList.remove('scrollbar-hidden')
      }
    }
  },
  methods: {
    showHistory() {
      if (this.init) {
        this.fetchHistory()
        this.init = false
      }

      this.isVisible = true
    },
    hideHistory() {
      this.isVisible = false
    },
    translate(sentence) {
      return Translator.trans(sentence)
    },
    getUsername(user, impersonator, isSystemChanged) {
      if (isSystemChanged) {
        return this.translate('entity_logger.system_changed')
      }

      if (impersonator) {
        return `${impersonator} ${this.translate('common.as')} ${user}`
      }

      return user
    },
    async fetchHistory() {
      this.loading = true

      const params = {
        dateFrom: this.searchForm.dateFrom,
        dateTo: this.searchForm.dateTo,
        entityName: this.entityName,
        entityId: this.entityId,
        date: this.date
      }

      let url = Routing.generate(this.routeName, params)

      await axios
        .get(url)
        .then(response => {
          this.historyItems = response.data
        })
        .catch(() => {
          toastr.error(this.translate('entity_logger.error.fetch'))
        })
        .then(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="less">
body.scrollbar-hidden {
  overflow: hidden;
}

.page-content .form-actions div.btn-set.pull-right {
  display: flex;
}

button.grid-history {
  margin: 0 10px;
}

.bootbox.modal.history-modal {
  display: block;
  background-color: rgba(0, 0, 0, 0.5);

  .modal-dialog.modal-lg {
    max-width: 100%;
    width: auto;
    padding: 30px;
    margin: 0;
  }

  #history-search {
    display: flex;
    margin-bottom: 20px;

    .date-container {
      display: flex;
      flex-direction: row;
      margin-right: 30px;

      .date-wrapper {
        display: flex;

        &:first-child {
          margin-right: 15px;
        }

        span {
          margin: auto 10px auto auto;
        }

        input {
          width: auto;
        }
      }
    }

    button {
      margin: auto 15px auto 0;
    }

    .error {
      margin: auto auto auto 15px;
      color: #f00;
      font-weight: bold;
    }
  }

  .no-records {
    text-align: center;
    display: block;
    font-weight: bold;
    margin-top: 20px;
  }

  table {
    caret-color: transparent;

    &.table-striped tbody tr:nth-child(even) {
      background: #fff;
    }

    &.data-table {
      width: 100%;

      th,
      td {
        word-break: break-word;
      }

      .data-column {
        width: 40%;

        &:first-of-type {
          padding-left: 10px;
        }
      }
    }

    td {
      max-width: 300px;
      word-wrap: break-word;
    }
  }
}

#client_show #addresses .btn-set {
  display: flex;
}

form .form-body .row:first-of-type .btn-set {
  display: flex;
}
</style>
